import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Heading, Button, Picture } from 'components';

// Style
import classNames from 'classnames/bind';
import styles from '../styles.pcss';
const cx = classNames.bind(styles);

const ResultStep = ({
  onClose,
  data: {
    title,
    contentText,
    buttonText,
    icon,
  },
}) => (
  <div>
    {icon && (
      <Picture
        className={cx('icon')}
        defaultImage={icon}
        alt={title}
      />
    )}
    <Heading level={1} isStyled={false}>
      <span dangerouslySetInnerHTML={{ __html: title }} />
    </Heading>
    <div className={cx('content', 'center')}>
      <p dangerouslySetInnerHTML={{ __html: contentText }} />
      <Button
        className={[cx('button'), cx('big')]}
        onClick={onClose}
        transformer
      >
        {buttonText}
      </Button>
    </div>
  </div>
);

ResultStep.propTypes = {
  onClose: PropTypes.func,
  data: PropTypes.shape({
    title: PropTypes.string,
    contentText: PropTypes.string,
    buttonText: PropTypes.string,
    icon: PropTypes.string,
  }),
};

export default ResultStep;
